import { Route } from '@angular/router';
import { AdminDashboardComponent } from 'app/components/admin-dashboard/admin-dashboard.component';
import { AuthGuard } from 'app/common/services/auth-guard.service';

export const adminDashboardRoute: Route = {
  path: ':cityId/admindashboard',
  component: AdminDashboardComponent,
  canActivate: [ AuthGuard ],
  data: { title: 'Панель управления' }
};